import {
  getCurrentInstance,
  reactive,
  onBeforeMount,
} from '@vue/composition-api'
import store from '@/store'
import router from '@/router'

import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import { groupBannerModel } from '@/models/banner/banner'

export default function useGroupBannerCreateEditForm(props) {
  const vm = getCurrentInstance().proxy

  const {
    createGroupBannerModel,
    editGroupBannerModel,
    fetchGroupBannerDetailModel,
  } = groupBannerModel()

  const { openSuccessModal, openDefaultErrorModal } = useValidationModal()

  const loading = reactive({ submit: false, information: false })

  const groupBannerDetail = reactive({
    information: {
      name: null,
      description: null,
      status: null,
      validFrom: null,
      validThrough: null,
      isDefault: false,
    },
    mappingBanner: [],
  })

  const resolveDateObject = dateObject => {
    const date = dateObject.date.split('-')
    const time = dateObject.time.split(':')

    const resolvedDate = `${date[2]}-${date[1]}-${date[0]} ${time[0]}:${time[1]}:00`

    return resolvedDate
  }

  const onSubmitCreateGroupBanner = () => {
    const groupBannerInformationForm = vm.$refs.createGroupBannerInformation.form

    const bannerMappingTable = vm.$refs.mappingBanner.setMappingBannerTable

    const groupBannerInformation = {
      name: groupBannerInformationForm.name,
      description: groupBannerInformationForm.description,
      status: groupBannerInformationForm.status,
      validFrom: resolveDateObject(groupBannerInformationForm.validFrom),
      validThrough: resolveDateObject(groupBannerInformationForm.validThrough),
      isDefault: groupBannerInformationForm.isDefault ? 1 : 0,
    }

    const {
      resolvedMappingBannerList,
      resolvedMappingSetBannerList,
    } = resolveMappingBannerList(bannerMappingTable.payload)

    createGroupBanner(
      groupBannerInformation,
      resolvedMappingBannerList,
      resolvedMappingSetBannerList,
    )
  }

  const onSubmitEditGroupBanner = () => {
    const groupBannerInformationForm = vm.$refs.createGroupBannerInformation.form

    const bannerMappingTable = vm.$refs.mappingBanner.setMappingBannerTable

    const groupBannerInformation = {
      name: groupBannerInformationForm.name,
      description: groupBannerInformationForm.description,
      status: groupBannerInformationForm.status,
      validFrom: resolveDateObject(groupBannerInformationForm.validFrom),
      validThrough: resolveDateObject(groupBannerInformationForm.validThrough),
      isDefault: groupBannerInformationForm.isDefault ? 1 : 0,
    }

    const {
      resolvedMappingBannerList,
      resolvedMappingSetBannerList,
    } = resolveMappingBannerList(bannerMappingTable.payload)

    editGroupBanner(
      groupBannerInformation,
      resolvedMappingBannerList,
      resolvedMappingSetBannerList,
    )
  }

  const resolveMappingBannerList = mappingBannerList => {
    const resolvedMappingBannerList = []
    const resolvedMappingSetBannerList = []

    const temptMappingBannerList = JSON.parse(JSON.stringify(mappingBannerList))

    temptMappingBannerList.map(banner => {
      if (banner.banner_id) {
        resolvedMappingBannerList.push({
          Seq: resolvedMappingBannerList.length + 1,
          Banner_Id: banner.banner_id,
        })
      }

      if (banner.set_banner_id) {
        resolvedMappingSetBannerList.push({
          Seq: resolvedMappingSetBannerList.length + 1,
          Set_Banner_Id: banner.set_banner_id,
        })
      }
    })

    return { resolvedMappingBannerList, resolvedMappingSetBannerList }
  }

  const onSubmit = () => {
    if (props?.isEdit) {
      return onSubmitEditGroupBanner()
    }

    return onSubmitCreateGroupBanner()
  }

  const createGroupBanner = (
    groupBannerInformation,
    mappingBannerList,
    mappingSetBannerList,
  ) => {
    window.$loading(true)
    loading.submit = true
    createGroupBannerModel.payload.Group_Name = groupBannerInformation.name
    createGroupBannerModel.payload.Description = groupBannerInformation.description
    createGroupBannerModel.payload.Status = groupBannerInformation.status
    createGroupBannerModel.payload.Valid_From = groupBannerInformation.validFrom
    createGroupBannerModel.payload.Valid_Through = groupBannerInformation.validThrough
    createGroupBannerModel.payload.isDefault = groupBannerInformation.isDefault
    createGroupBannerModel.payload.Banner_Mapping = mappingBannerList
    createGroupBannerModel.payload.Banner_Mapping_Other_Set = mappingSetBannerList

    store
      .dispatch('api/apiRequest', createGroupBannerModel)
      .then(response => {
        const redirectFunction = () => {
          router.push('/banner/group/Banner_Group')
        }

        openSuccessModal(
          'ทำรายการสำเร็จ !',
          undefined,
          undefined,
          undefined,
          redirectFunction,
        )
      })
      .catch(err => {
        openDefaultErrorModal(err)
      })
      .finally(() => {
        window.$loading(false)
        loading.submit = false
      })
  }

  const editGroupBanner = (
    groupBannerInformation,
    mappingBannerList,
    mappingSetBannerList,
  ) => {
    window.$loading(true)
    const groupId = router.currentRoute.params.id

    loading.submit = true
    editGroupBannerModel.payload.Group_Banner_Id = groupId
    editGroupBannerModel.payload.Group_Name = groupBannerInformation.name
    editGroupBannerModel.payload.Description = groupBannerInformation.description
    editGroupBannerModel.payload.Status = groupBannerInformation.status
    editGroupBannerModel.payload.Valid_From = groupBannerInformation.validFrom
    editGroupBannerModel.payload.Valid_Through = groupBannerInformation.validThrough
    editGroupBannerModel.payload.isDefault = groupBannerInformation.isDefault
    editGroupBannerModel.payload.Banner_Mapping = mappingBannerList
    editGroupBannerModel.payload.Banner_Mapping_Other_Set = mappingSetBannerList

    store
      .dispatch('api/apiRequest', editGroupBannerModel)
      .then(response => {
        const redirectFunction = () => {
          router.push('/banner/group/Banner_Group')
        }

        openSuccessModal(
          'ทำรายการสำเร็จ !',
          undefined,
          undefined,
          undefined,
          redirectFunction,
        )
      })
      .catch(err => {
        openDefaultErrorModal(err)
      })
      .finally(() => {
        window.$loading(false)
        loading.submit = false
      })
  }

  const fetchGroupBannerDetail = () => {
    window.$loading(true)
    const bannerGroupId = router.currentRoute.params.id
    fetchGroupBannerDetailModel.payload.Group_Banner_Id = bannerGroupId
    loading.information = true

    store
      .dispatch('api/apiRequest', fetchGroupBannerDetailModel)
      .then(response => {
        const InformationDetail = response.data.group_banner
        const mappingDetail = response.data.mapping_group_banners

        groupBannerDetail.information.name = InformationDetail.group_name
        groupBannerDetail.information.description = InformationDetail.description
        groupBannerDetail.information.status = InformationDetail.status
        groupBannerDetail.information.validFrom = InformationDetail.valid_from
        groupBannerDetail.information.validThrough = InformationDetail.valid_through
        groupBannerDetail.information.isDefault = InformationDetail.isdefault
        groupBannerDetail.mappingBanner = mappingDetail
      })

      .catch(err => {
        openDefaultErrorModal(err)
      })
      .finally(() => {
        window.$loading(false)
        loading.information = false
      })
  }

  onBeforeMount(() => {
    if (props?.isEdit) {
      fetchGroupBannerDetail()
    }
  })

  return { loading, groupBannerDetail, onSubmit }
}
